import React, { useLayoutEffect, useRef, useState } from 'react';
import { ArrowToggle, Button, Popup, Select, } from '@gravity-ui/uikit';
import { useBooleanState } from '../../react-utils';
export const TooltipButton = ({ domRef, buttonTitle = 'Settings', items, onUpdate, withSearch, onOutsideClick, }) => {
    var _a;
    const [width, setWidth] = useState(0);
    const [open, , , toggleOpen] = useBooleanState(false);
    const ref = useRef(null);
    useLayoutEffect(() => {
        var _a, _b;
        if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth) {
            setWidth((_b = ref.current) === null || _b === void 0 ? void 0 : _b.clientWidth);
        }
    }, [(_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth, buttonTitle]);
    return (React.createElement(Popup, { open: true, keepMounted: false, hasArrow: false, anchorRef: { current: domRef }, placement: 'right-start', offset: [10, -(width + 10)], onOutsideClick: onOutsideClick, modifiers: [
            {
                name: 'preventOverflow',
                enabled: false,
            },
        ] },
        React.createElement(Select, { onOpenChange: toggleOpen, renderControl: () => (React.createElement(Button, { ref: ref, view: 'flat' },
                buttonTitle,
                React.createElement(ArrowToggle, { direction: open ? 'top' : 'bottom' }))), options: items, onUpdate: (v) => onUpdate(v[0]), filterable: withSearch })));
};
